import { useQuery } from '@tanstack/react-query';
import { getSupplierUnderwritingData } from '@/services/reportService';

export const useGetUnderwritingData = () => {
    return useQuery({
        queryKey: ['supplier-underwriting'],
        queryFn: getSupplierUnderwritingData,
    });
};
